import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
// import { Errorhandlers } from './errorhandlers';
import {EnvLoadService} from '../../../../env-load/env-load.service';

@Injectable()
export class ExtensionServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    //private extnUrl = `${environment.extnUrl}/api/v1`;
    private extnUrl = `${this.envLoadService.extnUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http,
                private envLoadService: EnvLoadService) {
        this.companyId = global['loginUser'].curCmpnId;
    }

    /**
     * extension
     * 설치가능 extension 목록 조회
     * Mothod : Get
     * API No : 8.01
     * /api/v1/{cmpnNo}/extension
     */
    getExtensionList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * 설치된 Extension 목록 조회
     * Mothod : Get
     * API No : 8.02
     * /api/v1/{cmpnNo}/extension/install
     **/
    getInstalledExtensions(queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/install?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /** 현재 사용 안함
     * extension
     * Extension On/Off
     * Mothod : Put
     * API No : 8.03
     * /api/v1/{cmpnNo}/extension/{extApplNo}
     **/
    // updateExtensionUseYn(extApplNo, putData: any) {
    //     const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/${extApplNo}`;
    //
    //     return this.http
    //         .put(url, JSON.stringify(putData))
    //         .toPromise()
    //         .then(res => res)
    //         .catch(this.handleError);
    // }

    /**
     * extension
     * Extension 수정
     * Mothod : Put
     * API No : 8.04
     * /api/v1/{cmpnNo}/extension/{extApplInstlNo}
     **/
    updateExtension(extApplInstlNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/${extApplInstlNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * Extension 삭제
     * Mothod : Delete
     * API No : 8.05
     * /api/v1/{cmpnNo}/extension/{extApplInstlNo}
     **/
    deleteExtension(extApplInstlNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/${extApplInstlNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * Extension 등록
     * Mothod : Post
     * API No : 8.06
     * /api/v1/{cmpnNo}/extension/
     **/
    createExtension(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * 설치된 extension 상세
     * Mothod : Get
     * API No : 8.07
     * /api/v1/{cmpnNo}/extension/{extApplInstlNo}
     */
    getExtension(extApplInstlNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/${extApplInstlNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * Extension 인증완료
     * Mothod : Put
     * API No : 8.08
     * /api/v1/extension/{applId}/authorize
     **/
    authorizeExtension(applId, putData: any) {
        const url = `${this.apiUrl}/extension/${applId}/authorize`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * Extension 서비스 호출
     * Mothod : Get
     * API No : 8.09
     * /api/v1/extension/oauth/slack?cmpnId={cmpnId}&cmd=${cmd}&svcId=${svcId}&extId=${extId}&userId=${userId}&bspAccessToken=${bspAccessToken}
     **/
    requestExtensionSvc(extnType: string, queryString: string) {
        location.href = `${this.extnUrl}/extension/oauth/${extnType}?${queryString}`;

        // const url = `https://99eb1f0e.ngrok.io/api/v1/extension/oauth/slack?${queryString}`;
        // const url = `${this.extnUrl}/extension/oauth/slack?${queryString}`;

        // return this.http
        //     .get(url)
        //     .toPromise()
        //     .then(res => res)
        //     .catch(this.handleError);
    }

    /**
     * extension
     * linked user
     * Mothod : Put
     * API No : 8.10
     * /api/v1/{cmpnNo}/extension/{extApplInstlNo}/link
     **/
    updateLinkUser(extId, putData) {
        const extApplInstlNo = extId;
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/${extApplInstlNo}/link`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * command linked user
     * Mothod : Put
     * API No : 8.11
     * /api/v1/{cmpnNo}/extension/{extApplInstlNo}/messanger/link
     **/
    updateCmdLinkUser(extId, putData) {
        const extApplInstlNo = extId;
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/${extApplInstlNo}/messanger/link`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * extension
     * workspace 중복 체크
     * Mothod : Get
     * API No : 8.12
     * /api/v1/{cmpnNo}/extension/duplicate?value={value}&trgtNo={trgtNo}
     */
    getDuplWorkspace(queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/extension/duplicate?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/extension.services.ts